/**
 * A simple event bus for communication with the Plaid Link singleton.
 *
 * This module provides a lightweight way for components to trigger Plaid Link actions
 * without prop drilling or complex state management. The singleton component registers
 * its handlers here, and other components can call these functions to interact with Plaid.
 *
 * Usage:
 * - Components call plaidPrepare(), plaidOpen(), isPlaidReady()
 * - The PlaidLinkSingleton registers its handlers via registerPlaidLinkHandlers()
 * - No React context or providers needed - just module-level function calls
 */

let currentHandlers = {
  prepare: () => {},
  open: async () => {},
  getReady: () => false,
}

export function registerPlaidLinkHandlers(handlers) {
  currentHandlers = { ...currentHandlers, ...handlers }
}

export function plaidPrepare() {
  return currentHandlers.prepare?.()
}

export function plaidOpen() {
  return currentHandlers.open?.()
}

export function isPlaidReady() {
  return currentHandlers.getReady?.()
}
